import fromPairs from 'lodash/fromPairs';
import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';
import sumBy from 'lodash/sumBy';

import { getProductLabel } from '../../campaign-editor/transform-for-rendering';
import ChangeProductBudgetComment from './ChangeProductBudgetComment';
import ChangeProductBudgetForm from './ChangeProductBudgetForm';
import { WRITABLE_BUDGET_FIELDS } from './constants';
import patch from './patch';
import { getProductRowId } from './utils';

export default {
  label: 'Change Product Budget',
  value: 'Change Product Budget',
  Form: ChangeProductBudgetForm,
  Comment: ChangeProductBudgetComment,
  initialState(campaign, campaignLinesById) {
    const campaignLines = Object.values(campaignLinesById);
    const campaignLinesByProductRowId = groupBy(campaignLines, getProductRowId);

    const roundToTwoDecimals = value => parseFloat(value.toFixed(2));

    return {
      delta: 0,
      productAggregates: mapValues(campaignLinesByProductRowId, lines => {
        const rep = lines[0]; // representative line

        const values = fromPairs(
          WRITABLE_BUDGET_FIELDS.map(budgetField => [
            budgetField,
            roundToTwoDecimals(sumBy(lines, budgetField)),
          ]),
        );

        const { product } = rep;
        return {
          label: getProductLabel(product),
          product,
          // TransformForRendering func changes it to % value which leads to wrong values while calculating the spendable budget.
          // Hence it is converted back to a value b/w 0 and 1.
          adjustedFee: rep.adjustedFee / 100 || 0,
          lineIds: lines.map(({ id }) => id),
          oldValues: values,
          newValues: values,
        };
      }),
    };
  },
  patch,
};
